@if (selectedFormula !== null) {
	<div class="flex flex-col">
		@for (variable of selectedFormula?.variables; track variable) {
			<div>
				@if (variable.type === "multichoice") {
					<button
						mat-stroked-button
						color="primary"
						(click)="loadVariableMultichoice(variable)"
						class="w-full"
						style="margin: 8px 0 8px 0">
						{{ variable.description }}
						@if (variable.value) {
							<span>({{ variable.value | round: 3 }}{{ variable.unit }})</span>
						}
					</button>
				}
				@if (variable.type === "single") {
					<mat-form-field
						class="w-full"
						appearance="outline">
						<mat-label>
							{{ variable.description }}
							@if (variable.unit) {
								<span>({{ variable.unit }})</span>
							}
						</mat-label>
						<input
							matInput
							[(ngModel)]="variable.value"
							(ngModelChange)="clearResult()"
							(keyup.enter)="calculate()" />
						<mat-icon matSuffix>functions</mat-icon>
					</mat-form-field>
				}
			</div>
		}
		<div class="flex flex-row items-center gap-x-2 text-lg">
			<div class="font-bold">Résultat :</div>
			<div class="text-blue-500">{{ result ?? "-" }}</div>
			<div>{{ selectedFormula.unit }}</div>
		</div>
		<button
			mat-raised-button
			color="primary"
			class="w-full"
			(click)="calculate()"
			style="margin: 16px 0 16px 0">
			{{ "core.calculate" | translate }}
			<mat-icon style="margin-left: 16px">straighten</mat-icon>
		</button>
		<div>
			<div class="italic">{{ "FORMULAS_REFERENCES" | translate }}</div>
			<ul class="list-inside list-disc">
				@for (ref of selectedFormula?.reference; track ref) {
					<li>{{ ref.label }}</li>
				}
			</ul>
		</div>
	</div>
}
